export enum ActionTypes {
    INIT = 'INIT',
    PROCCESS = 'PROCCESS',
    ACCEPT = 'ACCEPT',
    PROCESSDOCUMENT = 'PROCESSDOCUMENT',
    ACCEPTDOCUMENT = 'ACCEPTDOCUMENT'
}
